"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = exports.CenteredIcon = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.CenteredIcon = (0, styled_components_1.default)(ui_icon_1.Icon)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  vertical-align: middle;\n"], ["\n  vertical-align: middle;\n"])));
exports.IconWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  ", "\n  transition: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  ", "\n  transition: ", ";\n"])), (0, ui_symbols_1.calcSpace)(5), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
}, function (_a) {
  var isTrailing = _a.isTrailing;
  return isTrailing ? 'right: 0;' : 'left: 0;';
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('MOTION.DEFAULT_TRANSITION', theme);
});
var templateObject_1, templateObject_2;